import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import mapValues from 'lodash/fp/mapValues';

import { storage } from '../../../configuration/setup/storage';

export type OnboardingState = {
    showTableSettingsTip: boolean;
    showQuickFilter: boolean;
    showTree: boolean;
    showShareLinkTip: boolean;
};

export type OnboardingTipKey = keyof OnboardingState;

export const defaultOnboardingState: OnboardingState = {
    showTableSettingsTip: true,
    showQuickFilter: true,
    showTree: true,
    showShareLinkTip: true,
};

export const testOnboardingState: OnboardingState = {
    showTableSettingsTip: false,
    showQuickFilter: false,
    showTree: false,
    showShareLinkTip: false,
};

const initialState = storage.load('onboarding') || defaultOnboardingState;

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState: initialState as OnboardingState,
    reducers: {
        onboardingToggled(state, action: PayloadAction<{ tip: OnboardingTipKey; toggle: boolean }>) {
            state[action.payload.tip] = action.payload.toggle;

            // Save state to localStorage
            storage.save('onboarding', state);
        },
        onboardingResetted(state, action: PayloadAction<boolean | undefined>) {
            const resetToDefault = action.payload === true;

            const newState = resetToDefault
                ? { ...defaultOnboardingState }
                : (mapValues(() => false, defaultOnboardingState) as OnboardingState);

            Object.assign(state, newState);

            // Save state to localStorage
            storage.save('onboarding', state);
        },
    },
});

export const { onboardingToggled, onboardingResetted } = onboardingSlice.actions;

export default onboardingSlice.reducer;
